import React, { useEffect } from "react";
import "./register.css";
import { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { service } from "../../../Network/Network";
import { useNavigate } from "react-router-dom";

function Register() {
  const navigate = useNavigate();
  const [values, setvalues] = useState({
    fullname: "",
    email: "",
    password: "",
    password2: "",
    age: "",
    gender: "",
    country: "",
  });
  const [Errors, setErrors] = useState({
    fullname: "",
    email: "",
    password: "",
    password2: "",
    age: "",
    gender: "",
    country: "",
  });
  const [fullName, setfullName] = useState("");
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [password2, setpassword2] = useState("");
  const [age, setage] = useState("");
  const [gender, setgender] = useState("");
  const [country, setcountry] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  

  const validateEmail = (email) => {
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email
      )
    ) {
      return true;
    }
    return false;
  };

  const validation = () => {
    let errors = {};
    let formIsValid = true;
    if (values.fullname.trim()) {
      errors.fullname = "";
      setfullName("");
    } else {
      formIsValid = false;
      errors.fullname = "Required Name Field";
      setfullName(" Input--errored");
    }
    if (values.email.trim()) {
     
      errors.email = "";
      setemail("");
     
    } else {
      formIsValid = false;
      errors.email = "Required Email Field";
      setemail(" Input--errored");
    }
    if (values.password.trim()) {
      if (values.password.length >= 6 && values.password.length <= 30) {
        if (values.password.trim()) {
          errors.password = "";
          setpassword("");
          errors.password2 = "Confirm Password";
          setpassword2("");
        } else {
          errors.password = "Password required";
          setpassword("");
        }
      } else {
        formIsValid = false;
        setpassword(" Input--errored");
        errors.password = "Length must be between 6 and 30";
      }
    } else {
      formIsValid = false;
      setpassword(" Input--errored");
      errors.password = "Required Password Field";
    }
    if (values.password === values.password2) {
      errors.password2 = "";
      setpassword2("");
    } else {
      formIsValid = false;
      errors.password2 = "passwords are not matching";
    }
    if (!(values.age.length === 0)) {
      errors.age = "";
      setage("");
    } else {
      formIsValid = false;
      errors.age = "Required age Field";
      setage(" Input--errored");
    }
    if (values.gender.trim()) {
      errors.gender = "";
      setgender("");
    } else {
      formIsValid = false;
      errors.gender = "Required gender Field";
      setgender(" Input--errored");
    }
    if (values.country.trim()) {
      errors.country = "";
      setcountry("");
    } else {
      formIsValid = false;
      errors.country = "Required country Field";
      setcountry(" Input--errored");
    }
    setErrors(errors);
    return formIsValid;
  };

  const submitHandler = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    
    // setvalues({
    //   fullname: fullName,
    //   email: email,
    //   password: password,
    //   password2: password2,
    //   age: age,
    //   gender: gender,
    //   country: country,
    // });
    if (validation()) {
      service.register(values).then((response) => {
        if (response.success === true && (response.data[0].user_id)) {
          localStorage.setItem("isLoggedIn", true);
          localStorage.setItem("userId", response.data[0].user_id);
          service.setCookie("userId", response.data[0].user_id, 30);
          service.setCookie("isLoggedIn", "true", 30);
          service.analytics().then((response) => {
            localStorage.setItem("deviceAnalytics", true);
          });
          const fileUrl = localStorage.getItem('downloadFileUrl');
            if (fileUrl && fileUrl.endsWith('.mp3')) {
              const link = document.createElement('a');
              link.href = fileUrl;
              link.download = '';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              localStorage.removeItem('downloadFileUrl');
            }
          navigate("/");
        }
        else{
          toast.error(response.message,{position: "bottom-left"});
        }
      });
    } else {
      console.log(`validation false something went wrong!!!`);
    }

    
  };
  return (
    <div id="register">
      <h1 className="heading">Welcome to KICC TV</h1>
      <ToastContainer />
      <div className="registerContainer">
        <div className="wrapper">
          <div className="leftContainer">
            <div className="imageContainer">
              <img
                src={require("../../../assets/images/kicctv logo.png")}
                alt="Logo"
              />
            </div>
          </div>
          {/* ( .leftContainer ) */}
          <div className="rightContainer">
            {/* <h1>Register</h1> */}
            <form onSubmit={submitHandler} method="post">
              <div className="form-group">
                <div className="oneByOne">
                  <label htmlFor="name" style={{ color: "red" }}>
                    {" "}
                    {Errors.fullname}{" "}
                  </label>
                  <label htmlFor="name">Full Name</label>
                  <input
                    name="fullname"
                    type="text"
                    id="fullName"
                    onChange={(e) => {
                      setfullName(e.target.value);
                      const { name, value } = e.target;
                      setvalues({
                        ...values,
                        [name]: value,
                      });
                    }}
                  />
                </div>
                <div className="oneByOne">
                  <label htmlFor="age" style={{ color: "red" }}>
                    {" "}
                    {Errors.age}{" "}
                  </label>
                  <label htmlFor="age">Age</label>
                  <input
                    type="date"
                    id="age"
                    name="age"
                    onChange={(e) => {
                      setage(e.target.value);
                      const { name, value } = e.target;
                      setvalues({
                        ...values,
                        [name]: value,
                      });
                    }}
                    value={values.age}
                  />
                </div>
              </div>

              <div className="form-group">
                <div className="oneByOne">
                  <label htmlFor="email" style={{ color: "red" }}>
                    {" "}
                    {Errors.email}{" "}
                  </label>
                  <label htmlFor="email">Email</label>
                  <input
                    name="email"
                    type="email"
                    id="email"
                    onChange={(e) => {
                      setemail(e.target.value);
                      const { name, value } = e.target;
                      setvalues({
                        ...values,
                        [name]: value,
                      });
                    }}
                  />
                </div>
                <div className="oneByOne">
                  <label htmlFor="gender" style={{ color: "red" }}>
                    {" "}
                    {Errors.gender}{" "}
                  </label>
                  <label htmlFor="gender">Gender</label>
                  <select
                    name="gender"
                    id="gender"
                    onChange={(e) => {
                      setgender(e.target.value);
                      const { name, value } = e.target;
                      setvalues({
                        ...values,
                        [name]: value,
                      });
                    }}
                  >
                    <option value="" disabled selected>
                      - Select -
                    </option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <div className="oneByOne">
                  <label htmlFor="password" style={{ color: "red" }}>
                    {" "}
                    {Errors.password}{" "}
                  </label>
                  <label htmlFor="password">Password</label>
                  <input
                    name="password"
                    type="password"
                    id="password"
                    onChange={(e) => {
                      setpassword(e.target.value);
                      const { name, value } = e.target;
                      setvalues({
                        ...values,
                        [name]: value,
                      });
                    }}
                  />
                </div>
                <div className="oneByOne">
                  <label htmlFor="country" style={{ color: "red" }}>
                    {" "}
                    {Errors.country}{" "}
                  </label>
                  <label htmlFor="country">Country</label>
                  <select
                    id="country"
                    name="country"
                    onChange={(e) => {
                      setcountry(e.target.value);
                      const { name, value } = e.target;
                      setvalues({
                        ...values,
                        [name]: value,
                      });
                    }}
                  >
                    <option>select country</option>
                    <option value="AF">Afghanistan</option>
                    <option value="AX">Aland Islands</option>
                    <option value="AL">Albania</option>
                    <option value="DZ">Algeria</option>
                    <option value="AS">American Samoa</option>
                    <option value="AD">Andorra</option>
                    <option value="AO">Angola</option>
                    <option value="AI">Anguilla</option>
                    <option value="AQ">Antarctica</option>
                    <option value="AG">Antigua and Barbuda</option>
                    <option value="AR">Argentina</option>
                    <option value="AM">Armenia</option>
                    <option value="AW">Aruba</option>
                    <option value="AU">Australia</option>
                    <option value="AT">Austria</option>
                    <option value="AZ">Azerbaijan</option>
                    <option value="BS">Bahamas</option>
                    <option value="BH">Bahrain</option>
                    <option value="BD">Bangladesh</option>
                    <option value="BB">Barbados</option>
                    <option value="BY">Belarus</option>
                    <option value="BE">Belgium</option>
                    <option value="BZ">Belize</option>
                    <option value="BJ">Benin</option>
                    <option value="BM">Bermuda</option>
                    <option value="BT">Bhutan</option>
                    <option value="BO">Bolivia</option>
                    <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                    <option value="BA">Bosnia and Herzegovina</option>
                    <option value="BW">Botswana</option>
                    <option value="BV">Bouvet Island</option>
                    <option value="BR">Brazil</option>
                    <option value="IO">British Indian Ocean Territory</option>
                    <option value="BN">Brunei Darussalam</option>
                    <option value="BG">Bulgaria</option>
                    <option value="BF">Burkina Faso</option>
                    <option value="BI">Burundi</option>
                    <option value="KH">Cambodia</option>
                    <option value="CM">Cameroon</option>
                    <option value="CA">Canada</option>
                    <option value="CV">Cape Verde</option>
                    <option value="KY">Cayman Islands</option>
                    <option value="CF">Central African Republic</option>
                    <option value="TD">Chad</option>
                    <option value="CL">Chile</option>
                    <option value="CN">China</option>
                    <option value="CX">Christmas Island</option>
                    <option value="CC">Cocos (Keeling) Islands</option>
                    <option value="CO">Colombia</option>
                    <option value="KM">Comoros</option>
                    <option value="CG">Congo</option>
                    <option value="CD">
                      Congo, Democratic Republic of the Congo
                    </option>
                    <option value="CK">Cook Islands</option>
                    <option value="CR">Costa Rica</option>
                    <option value="CI">Cote D'Ivoire</option>
                    <option value="HR">Croatia</option>
                    <option value="CU">Cuba</option>
                    <option value="CW">Curacao</option>
                    <option value="CY">Cyprus</option>
                    <option value="CZ">Czech Republic</option>
                    <option value="DK">Denmark</option>
                    <option value="DJ">Djibouti</option>
                    <option value="DM">Dominica</option>
                    <option value="DO">Dominican Republic</option>
                    <option value="EC">Ecuador</option>
                    <option value="EG">Egypt</option>
                    <option value="SV">El Salvador</option>
                    <option value="GQ">Equatorial Guinea</option>
                    <option value="ER">Eritrea</option>
                    <option value="EE">Estonia</option>
                    <option value="ET">Ethiopia</option>
                    <option value="FK">Falkland Islands (Malvinas)</option>
                    <option value="FO">Faroe Islands</option>
                    <option value="FJ">Fiji</option>
                    <option value="FI">Finland</option>
                    <option value="FR">France</option>
                    <option value="GF">French Guiana</option>
                    <option value="PF">French Polynesia</option>
                    <option value="TF">French Southern Territories</option>
                    <option value="GA">Gabon</option>
                    <option value="GM">Gambia</option>
                    <option value="GE">Georgia</option>
                    <option value="DE">Germany</option>
                    <option value="GH">Ghana</option>
                    <option value="GI">Gibraltar</option>
                    <option value="GR">Greece</option>
                    <option value="GL">Greenland</option>
                    <option value="GD">Grenada</option>
                    <option value="GP">Guadeloupe</option>
                    <option value="GU">Guam</option>
                    <option value="GT">Guatemala</option>
                    <option value="GG">Guernsey</option>
                    <option value="GN">Guinea</option>
                    <option value="GW">Guinea-Bissau</option>
                    <option value="GY">Guyana</option>
                    <option value="HT">Haiti</option>
                    <option value="HM">
                      Heard Island and Mcdonald Islands
                    </option>
                    <option value="VA">Holy See (Vatican City State)</option>
                    <option value="HN">Honduras</option>
                    <option value="HK">Hong Kong</option>
                    <option value="HU">Hungary</option>
                    <option value="IS">Iceland</option>
                    <option value="IN">India</option>
                    <option value="ID">Indonesia</option>
                    <option value="IR">Iran, Islamic Republic of</option>
                    <option value="IQ">Iraq</option>
                    <option value="IE">Ireland</option>
                    <option value="IM">Isle of Man</option>
                    <option value="IL">Israel</option>
                    <option value="IT">Italy</option>
                    <option value="JM">Jamaica</option>
                    <option value="JP">Japan</option>
                    <option value="JE">Jersey</option>
                    <option value="JO">Jordan</option>
                    <option value="KZ">Kazakhstan</option>
                    <option value="KE">Kenya</option>
                    <option value="KI">Kiribati</option>
                    <option value="KP">
                      Korea, Democratic People's Republic of
                    </option>
                    <option value="KR">Korea, Republic of</option>
                    <option value="XK">Kosovo</option>
                    <option value="KW">Kuwait</option>
                    <option value="KG">Kyrgyzstan</option>
                    <option value="LA">Lao People's Democratic Republic</option>
                    <option value="LV">Latvia</option>
                    <option value="LB">Lebanon</option>
                    <option value="LS">Lesotho</option>
                    <option value="LR">Liberia</option>
                    <option value="LY">Libyan Arab Jamahiriya</option>
                    <option value="LI">Liechtenstein</option>
                    <option value="LT">Lithuania</option>
                    <option value="LU">Luxembourg</option>
                    <option value="MO">Macao</option>
                    <option value="MK">
                      Macedonia, the Former Yugoslav Republic of
                    </option>
                    <option value="MG">Madagascar</option>
                    <option value="MW">Malawi</option>
                    <option value="MY">Malaysia</option>
                    <option value="MV">Maldives</option>
                    <option value="ML">Mali</option>
                    <option value="MT">Malta</option>
                    <option value="MH">Marshall Islands</option>
                    <option value="MQ">Martinique</option>
                    <option value="MR">Mauritania</option>
                    <option value="MU">Mauritius</option>
                    <option value="YT">Mayotte</option>
                    <option value="MX">Mexico</option>
                    <option value="FM">Micronesia, Federated States of</option>
                    <option value="MD">Moldova, Republic of</option>
                    <option value="MC">Monaco</option>
                    <option value="MN">Mongolia</option>
                    <option value="ME">Montenegro</option>
                    <option value="MS">Montserrat</option>
                    <option value="MA">Morocco</option>
                    <option value="MZ">Mozambique</option>
                    <option value="MM">Myanmar</option>
                    <option value="NA">Namibia</option>
                    <option value="NR">Nauru</option>
                    <option value="NP">Nepal</option>
                    <option value="NL">Netherlands</option>
                    <option value="AN">Netherlands Antilles</option>
                    <option value="NC">New Caledonia</option>
                    <option value="NZ">New Zealand</option>
                    <option value="NI">Nicaragua</option>
                    <option value="NE">Niger</option>
                    <option value="NG">Nigeria</option>
                    <option value="NU">Niue</option>
                    <option value="NF">Norfolk Island</option>
                    <option value="MP">Northern Mariana Islands</option>
                    <option value="NO">Norway</option>
                    <option value="OM">Oman</option>
                    <option value="PK">Pakistan</option>
                    <option value="PW">Palau</option>
                    <option value="PS">Palestinian Territory, Occupied</option>
                    <option value="PA">Panama</option>
                    <option value="PG">Papua New Guinea</option>
                    <option value="PY">Paraguay</option>
                    <option value="PE">Peru</option>
                    <option value="PH">Philippines</option>
                    <option value="PN">Pitcairn</option>
                    <option value="PL">Poland</option>
                    <option value="PT">Portugal</option>
                    <option value="PR">Puerto Rico</option>
                    <option value="QA">Qatar</option>
                    <option value="RE">Reunion</option>
                    <option value="RO">Romania</option>
                    <option value="RU">Russian Federation</option>
                    <option value="RW">Rwanda</option>
                    <option value="BL">Saint Barthelemy</option>
                    <option value="SH">Saint Helena</option>
                    <option value="KN">Saint Kitts and Nevis</option>
                    <option value="LC">Saint Lucia</option>
                    <option value="MF">Saint Martin</option>
                    <option value="PM">Saint Pierre and Miquelon</option>
                    <option value="VC">Saint Vincent and the Grenadines</option>
                    <option value="WS">Samoa</option>
                    <option value="SM">San Marino</option>
                    <option value="ST">Sao Tome and Principe</option>
                    <option value="SA">Saudi Arabia</option>
                    <option value="SN">Senegal</option>
                    <option value="RS">Serbia</option>
                    <option value="CS">Serbia and Montenegro</option>
                    <option value="SC">Seychelles</option>
                    <option value="SL">Sierra Leone</option>
                    <option value="SG">Singapore</option>
                    <option value="SX">Sint Maarten</option>
                    <option value="SK">Slovakia</option>
                    <option value="SI">Slovenia</option>
                    <option value="SB">Solomon Islands</option>
                    <option value="SO">Somalia</option>
                    <option value="ZA">South Africa</option>
                    <option value="GS">
                      South Georgia and the South Sandwich Islands
                    </option>
                    <option value="SS">South Sudan</option>
                    <option value="ES">Spain</option>
                    <option value="LK">Sri Lanka</option>
                    <option value="SD">Sudan</option>
                    <option value="SR">Suriname</option>
                    <option value="SJ">Svalbard and Jan Mayen</option>
                    <option value="SZ">Swaziland</option>
                    <option value="SE">Sweden</option>
                    <option value="CH">Switzerland</option>
                    <option value="SY">Syrian Arab Republic</option>
                    <option value="TW">Taiwan, Province of China</option>
                    <option value="TJ">Tajikistan</option>
                    <option value="TZ">Tanzania, United Republic of</option>
                    <option value="TH">Thailand</option>
                    <option value="TL">Timor-Leste</option>
                    <option value="TG">Togo</option>
                    <option value="TK">Tokelau</option>
                    <option value="TO">Tonga</option>
                    <option value="TT">Trinidad and Tobago</option>
                    <option value="TN">Tunisia</option>
                    <option value="TR">Turkey</option>
                    <option value="TM">Turkmenistan</option>
                    <option value="TC">Turks and Caicos Islands</option>
                    <option value="TV">Tuvalu</option>
                    <option value="UG">Uganda</option>
                    <option value="UA">Ukraine</option>
                    <option value="AE">United Arab Emirates</option>
                    <option value="GB">United Kingdom</option>
                    <option value="US">United States</option>
                    <option value="UM">
                      United States Minor Outlying Islands
                    </option>
                    <option value="UY">Uruguay</option>
                    <option value="UZ">Uzbekistan</option>
                    <option value="VU">Vanuatu</option>
                    <option value="VE">Venezuela</option>
                    <option value="VN">Viet Nam</option>
                    <option value="VG">Virgin Islands, British</option>
                    <option value="VI">Virgin Islands, U.s.</option>
                    <option value="WF">Wallis and Futuna</option>
                    <option value="EH">Western Sahara</option>
                    <option value="YE">Yemen</option>
                    <option value="ZM">Zambia</option>
                    <option value="ZW">Zimbabwe</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <div className="oneByOne">
                  <label htmlFor="confirmPassword" style={{ color: "red" }}>
                    {" "}
                    {Errors.password2}{" "}
                  </label>
                  <label htmlFor="confirmPassword">Confirm Password</label>
                  <input
                    name="password2"
                    type="password"
                    id="confirmPassword"
                    onChange={(e) => {
                      setpassword2(e.target.value);
                      const { name, value } = e.target;
                      setvalues({
                        ...values,
                        [name]: value,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="form-group">
                <div className="oneByOne">
                  <button type="submit">Register</button>
                </div>
                <div className="oneByOne">
                  <p>
                    By clicking on 'Register', you accept our{" "}
                    <span>Terms and Conditions of Use and Privacy Policy.</span>{" "}
                  </p>
                </div>
              </div>
            </form>
            <p>
              Already have an account?<span style={{cursor:'pointer'}} onClick={()=>navigate("/login")}> Login</span>
            </p>
          </div>
          {/* ( .rightContainer ) */}
        </div>{" "}
        {/* ( .wrapper ) */}
      </div>{" "}
      {/* ( .registerContainer ) */}
    </div> // ( #register )
  );
}

export default Register;
